<button
  app-button
  buttonType="outline"
  buttonShape="circle"
  (click)="handleHelpClicked()"
  matTooltip="Help">
    <fa-icon icon="question"></fa-icon>
</button>